import { useMutation, useQuery } from '@apollo/client'
import {
  CREATE_MIGRANTS_REPORT,
  GET_MIGRANTS_DATA_SOURCE_CHOOSEN,
  GET_MIGRANTS_FORM_BY_GROUPS_CATEGORY_SUB_ID,
} from '../../../../graphql/Catalog/Migrants/migrantsProcess'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import Box from '../../../Global/Box'
import { use, useEffect, useState } from 'react'
import { useLoading } from '../../../../LoadingOverlay/LoadingOverlayContext'
import { useHistory } from 'react-router-dom'
import MigratesPreviewFormField from './MigratesPreviewFormField'

const extensions_allowed_file = ['.pdf']
const extensions_allowed_image = ['.png', '.jpg', '.jpeg']
const sizeMaxFile = 8 // EXPRESADO EN MB.

const MigrantsProcessForms = ({
  processController = {
    group_category: {
      id: null,
      name: null,
    },
    group_category_sub: {
      id: null,
      name: null,
    },
  },
}) => {
  // -------------- Hooks --------------
  const { showLoading, hideLoading } = useLoading()
  const history = useHistory()
  const [data, setData] = useState(null)
  const [maxFiles, setMaxFiles] = useState(1)
  const [validationSchemaRules, setValidationSchemaRules] = useState({})
  const [validationSchema, setValidationSchema] = useState(
    Yup.object().shape(validationSchemaRules)
  )
  // -------------- Queries and Mutations --------------
  const {
    data: dataForm,
    loading: loadingForm,
    error: errorForm,
  } = useQuery(GET_MIGRANTS_FORM_BY_GROUPS_CATEGORY_SUB_ID, {
    variables: {
      group_category_sub_id: processController.group_category_sub.id,
    },
  })
  const [getDataSource] = useMutation(GET_MIGRANTS_DATA_SOURCE_CHOOSEN)
  const [CreateReport] = useMutation(CREATE_MIGRANTS_REPORT)

  // -------------- Schema --------------
  const {
    methods,
    handleSubmit,
    formState: { errors },
    control,
    reset,
    setValue,
    getValues,
  } = useForm({
    resolver: yupResolver(validationSchema),
  })
  // -------------- UseEffect --------------
  useEffect(() => {
    if (!loadingForm && !errorForm) {
      if (dataForm?.getMigrantsFormByGroupsCategorySubId) {
        processingDataReceived(dataForm.getMigrantsFormByGroupsCategorySubId)
      }
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataForm, loadingForm, errorForm])

  useEffect(() => {
    setValidationSchema(Yup.object().shape(validationSchemaRules))
  }, [validationSchemaRules])
  // -------------- Functions --------------
  const processingDataReceived = async (dataRespProc) => {
    let dataFieldsOfForm = []
    let validationSchemaField = {}

    for await (let field of dataRespProc.FieldsOfForm) {
      let choosenSourceData = null
      if (
        field.TypeOfField.name === 'choosen_db' &&
        field.field_type_choosen_source_id
      ) {
        const { data } = await getDataSource({
          variables: {
            idFormFieldTypeChoosenSource: parseInt(
              field.field_type_choosen_source_id
            ),
          },
        })
        choosenSourceData = data.getDataSourceOfFormFieldTypeChoosenSource
      }

      if (field.FieldYupRulesOfFormField.length > 0) {
        const schema = processBuildingRules({
          typeYup: field.TypeOfField.type,
          typeField: field.TypeOfField.name,
          fieldYupRules: field.FieldYupRulesOfFormField,
        })
        validationSchemaField[field.name] = schema
      }

      dataFieldsOfForm.push({ ...field, choosenSourceData })
    }
    setValidationSchemaRules((old) => ({ ...old, ...validationSchemaField }))
    setData({ ...dataRespProc, FieldsOfForm: dataFieldsOfForm })
  }

  const processBuildingRules = ({ typeYup, typeField, fieldYupRules }) => {
    let schema = null
    if (typeYup === 'file' && typeField === 'file') {
      schema = Yup.string()
    } else if (typeYup === 'file' && typeField === 'image') {
      schema = Yup.array().nullable()
    } else {
      schema = Yup[typeYup]()
    }

    for (const fieldYupRule of fieldYupRules) {
      const yupRuleOfField = fieldYupRule.YupRuleOfField

      if (!yupRuleOfField) continue

      switch (yupRuleOfField.yup_rule) {
        case 'required':
          // if (!yupRuleOfField.active_on_web)
          schema = schema.required(yupRuleOfField?.message)
          break
        case 'min':
          schema = schema.min(
            parseInt(yupRuleOfField?.options),
            yupRuleOfField?.message
          )
          break
        case 'max':
          schema = schema.max(
            parseInt(yupRuleOfField?.options),
            yupRuleOfField?.message
          )
          if (typeField === 'image')
            setMaxFiles(parseInt(yupRuleOfField?.options))
          break
        case 'email':
          schema = schema.email(yupRuleOfField?.message)
          break
        case 'matches':
          schema = schema.matches(
            yupRuleOfField?.options,
            yupRuleOfField?.message
          )
          break
        default:
          break
      }
    }

    return schema
  }

  const onSubmit = async (Data) => {
    showLoading()
    try {
      let files = []
      let filesImg = []
      for (const fieldForm of data?.FieldsOfForm) {
        if (
          fieldForm?.TypeOfField?.name == 'image' ||
          fieldForm?.TypeOfField?.name == 'file'
        ) {
          let findRequired = fieldForm?.FieldYupRulesOfFormField?.find(
            (rule) => rule?.YupRuleOfField?.yup_rule === 'required'
          )
          if (getValues(fieldForm?.name).length == 0 && findRequired)
            return toastSweetAlert({
              mode: 'error',
              message: `${fieldForm?.label} es obligatorio`,
            })
          else {
            let currentFile = getValues(fieldForm?.name)[0]
            if (currentFile) {
              if (currentFile?.size / 1048576 > sizeMaxFile)
                return toastSweetAlert({
                  mode: 'error',
                  message: `${fieldForm?.label} no puede superar los ${sizeMaxFile}MB`,
                })

              if (fieldForm?.TypeOfField?.name == 'file')
                files.push(currentFile)
              else filesImg.push({
                file: currentFile,
                label: fieldForm?.label || null,
              })
            }
          }
        }
      }
      let input = {
        files,
        filesImg,
        data_form_json: JSON.stringify(Data),
        group_id: 1,
        group_category_sub_id: parseInt(
          processController?.group_category_sub?.id
        ),
        group_category_id: parseInt(processController?.group_category?.id),
      }
      const resCreateReport = await CreateReport({
        variables: {
          input,
        },
      })
      if (resCreateReport)
        return (
          toastSweetAlert({
            mode: 'ok',
            titleMessage: 'Trámite realizado con éxito',
            message:
              'Puedes ver la actualización de tu trámite en el panel de historial de trámites.',
          }),
          history.push('/dashboardMigrants/logged')
        )
      else
        return toastSweetAlert({
          mode: 'error',
          message: 'Error al crear el trámite, por favor intente nuevamente.',
        })
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  return (
    <div className="migrants-process-forms">
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          {data && (
            <Box
              title={`Detalles del trámite`}
              btnRedPath="/dashboardMigrants/logged"
              btnRedTxt="CANCELAR"
              errors={errors}
              btnSubmit={true}
              btnSubmitText="REALIZAR TRÁMITE"
              content={
                <>
                  <div className="row">
                    <MigratesPreviewFormField
                      control={control}
                      fieldsData={data?.FieldsOfForm}
                      // onChangeFile={handleFile}
                      // onChangeFileImg={handleFileImg}
                      // removeFile={handleRemoveFile}
                      maxFiles={maxFiles}
                      newDropAttachment={true}
                    />
                  </div>
                </>
              }
            />
          )}
        </form>
      </FormProvider>
    </div>
  )
}

export default MigrantsProcessForms
